module.exports = __webpack_public_path__ + "static/media/bookmevenue_logo.8bc65ab5.png";